var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('p',[_vm._v("请打开浏览器控制台，然后点击下面的按钮")]),_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.handleNewError}},[_vm._v("触发一个错误")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }